import { Box, SxProps, Typography } from '@mui/material';
import React from 'react';

interface Props {
  mv?: number;
  children: any;
  color?: string;
  bold?: boolean;
  size?: string;
  sx?: SxProps;
  variant?:
    | 'button'
    | 'caption'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'inherit'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'overline'
    | undefined;
}

const Text: React.FC<Props> = ({
  mv,
  children,
  color,
  bold = false,
  size = 'default',
  sx,
  variant = 'body1',
}) => {
  const defineSize = () => {
    if (size === 'default') return 16;
    if (size === 'small') return 12;
    if (size === 'medium') return 18;
    if (size === 'big') return 25;
    if (size === 'huge') return 35;
    if (size === 'guide-huge') return 45;
    if (size === 'guide-mobile-huge') return 18;
  };
  return (
    <Box sx={{ mt: mv, mb: mv }}>
      <Typography
        sx={sx}
        style={{
          wordBreak: 'break-all',
          whiteSpace: 'normal',
          color: color,
          fontWeight: bold ? 'bold' : 'regular',
          fontSize: defineSize(),
        }}
        variant={variant}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default Text;
